/* Shy Sprout Studio — Shopify theme JS (vanilla, no build step, progressive enhancement) */
(function () {
  "use strict";

  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var money = (window.Shopify && window.Shopify.formatMoney) ? null : null;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* -------------------------------------------------- money formatting */
  function formatMoney(cents) {
    // Uses the shop's money format string injected by Liquid (see theme.liquid).
    var fmt = window.themeMoneyFormat || "${{amount}}";
    var value = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount\s*\}\}/g, value)
             .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100));
  }

  /* ---------------------------------------------------- ambient motion */
  function initLeaves() {
    if (reduceMotion) return;
    $$("[data-leaffield]").forEach(function (field) {
      if (field.dataset.built) return;
      field.dataset.built = "1";
      var count = parseInt(field.dataset.count, 10) || 6;
      var hues = [118, 96, 138, 78, 52];
      for (var i = 0; i < count; i++) {
        var leaf = document.createElement("span");
        leaf.className = "leaffield__leaf leaffield__leaf--" + (i % 2);
        leaf.style.left = Math.round((i / count) * 100 + (Math.random() * 8 - 4)) + "%";
        leaf.style.animationDelay = "-" + (Math.random() * 14).toFixed(2) + "s";
        leaf.style.animationDuration = (15 + Math.random() * 14).toFixed(2) + "s";
        leaf.style.setProperty("--lf-scale", (0.6 + Math.random() * 0.8).toFixed(2));
        leaf.style.setProperty("--lf-hue", hues[i % 5]);
        field.appendChild(leaf);
      }
    });
  }

  function spawnBurst(x, y) {
    if (reduceMotion || document.body.dataset.burst === "false") return;
    var root = document.createElement("div");
    root.className = "burst";
    root.style.left = x + "px";
    root.style.top = y + "px";
    var hues = [118, 96, 138, 78];
    for (var i = 0; i < 7; i++) {
      var s = document.createElement("span");
      var ang = (Math.PI * 2 * i) / 7 + Math.random() * 0.6;
      var dist = 46 + Math.random() * 40;
      s.style.setProperty("--bx", Math.cos(ang) * dist + "px");
      s.style.setProperty("--by", Math.sin(ang) * dist - 30 + "px");
      s.style.setProperty("--br", Math.round(Math.random() * 540 - 270) + "deg");
      s.style.background = "linear-gradient(160deg, hsl(" + hues[i % 4] + " 50% 62%), var(--leaf))";
      root.appendChild(s);
    }
    document.body.appendChild(root);
    setTimeout(function () { root.remove(); }, 900);
  }

  /* ------------------------------------------------- lazy mascot video */
  function initLazyVideo() {
    var vids = $$("[data-lazy-video]");
    if (!vids.length) return;
    var load = function (video) {
      if (video.dataset.loaded) return;
      video.dataset.loaded = "1";
      var source = video.querySelector("source[data-src]");
      if (source && !source.src) { source.src = source.dataset.src; video.load(); }
      if (video.hasAttribute("data-autoplay") && !reduceMotion) {
        var p = video.play(); if (p && p.catch) p.catch(function () {});
      }
    };
    if (!("IntersectionObserver" in window)) { vids.forEach(load); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { load(e.target); io.unobserve(e.target); } });
    }, { rootMargin: "200px" });
    vids.forEach(function (v) { io.observe(v); });
  }

  /* ------------------------------------------------------- cart badges */
  function bump(el) {
    if (!el || reduceMotion) return;
    el.classList.remove("bump");
    requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add("bump"); }); });
  }
  function setCartCount(n) {
    var headerEl = $("[data-cart-quantity]");
    var badgeEl = $("[data-cart-badge]");
    if (headerEl) { headerEl.textContent = n; headerEl.hidden = n <= 0; if (n > 0) bump(headerEl); }
    if (badgeEl) { badgeEl.textContent = n; badgeEl.hidden = n <= 0; if (n > 0) bump(badgeEl); }
  }

  function cartAdd(id, quantity) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: id, quantity: quantity || 1 }),
    }).then(function (r) { if (!r.ok) return r.json().then(function (e) { throw e; }); return r.json(); });
  }
  function cartChange(key, quantity) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity }),
    }).then(function (r) { return r.json(); });
  }
  function getCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); });
  }

  /* --------------------------------------------------------- drawers */
  function focusables(el) {
    var f = el.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea, [tabindex]:not([tabindex="-1"])');
    return Array.prototype.filter.call(f, function (n) { return n.offsetParent !== null; });
  }
  function openDrawer(el, opener) {
    if (!el) return;
    el._opener = opener || document.activeElement;
    el.hidden = false;
    document.body.style.overflow = "hidden";
    requestAnimationFrame(function () { el.classList.add("is-open"); });
    var f = focusables(el);
    if (f.length) setTimeout(function () { f[0].focus(); }, 60);
    el._trap = function (e) {
      if (e.key !== "Tab") return;
      var list = focusables(el);
      if (!list.length) return;
      var first = list[0], last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };
    el.addEventListener("keydown", el._trap);
  }
  function closeDrawer(el) {
    if (!el || el.hidden) return;
    el.classList.remove("is-open");
    document.body.style.overflow = "";
    if (el._trap) { el.removeEventListener("keydown", el._trap); el._trap = null; }
    if (el.id) {
      Array.prototype.forEach.call(document.querySelectorAll('[aria-controls="' + el.id + '"]'), function (b) { b.setAttribute("aria-expanded", "false"); });
    }
    setTimeout(function () { el.hidden = true; }, 340);
    if (el._opener && el._opener.focus) { try { el._opener.focus(); } catch (err) {} }
  }
  function initDrawers() {
    var menu = $("[data-menu-drawer]");
    $$("[data-menu-open]").forEach(function (b) { b.addEventListener("click", function () { b.setAttribute("aria-expanded", "true"); openDrawer(menu, b); }); });
    $$("[data-menu-close]").forEach(function (b) { b.addEventListener("click", function () { closeDrawer(menu); }); });

    var cart = $("[data-cart-drawer]");
    $$("[data-cart-open]").forEach(function (b) {
      b.addEventListener("click", function (e) { e.preventDefault(); openDrawer(cart, b); });
    });
    $$("[data-cart-close]").forEach(function (b) { b.addEventListener("click", function () { closeDrawer(cart); }); });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        [menu, cart, $("[data-search-modal]")].forEach(function (d) { if (d && !d.hidden) closeDrawer(d); });
      }
    });
  }

  /* --------------------------------------------------- search modal */
  function initSearch() {
    var modal = $("[data-search-modal]");
    if (!modal) return;
    var input = $("[data-search-input]", modal);
    $$("[data-search-open]").forEach(function (b) {
      b.addEventListener("click", function () { openDrawer(modal, b); if (input) input.focus(); });
    });
    $$("[data-search-close]").forEach(function (b) { b.addEventListener("click", function () { closeDrawer(modal); }); });

    var container = $("[data-predictive]", modal);
    if (!input || !container) return;
    var timer, lastQ = "";
    input.addEventListener("input", function () {
      var q = input.value.trim();
      if (q === lastQ) return;
      lastQ = q;
      clearTimeout(timer);
      if (q.length < 2) { container.innerHTML = ""; return; }
      timer = setTimeout(function () { predict(q, container); }, 220);
    });
  }
  function predict(q, container) {
    var types = [];
    if (document.body.dataset.searchProducts !== "false") types.push("product");
    if (document.body.dataset.searchPages !== "false") { types.push("page"); types.push("article"); }
    var url = "/search/suggest.json?q=" + encodeURIComponent(q) +
      "&resources[type]=" + types.join(",") + "&resources[limit]=6&resources[options][unavailable_products]=last";
    fetch(url, { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var res = (data.resources && data.resources.results) || {};
        var html = "";
        if (res.products && res.products.length) {
          html += '<div class="predictive__group-title">Products</div>';
          res.products.forEach(function (p) {
            var img = (p.image) ? '<span class="predictive__thumb"><img src="' + p.image + '" alt="" width="48" height="48" loading="lazy"></span>' : '<span class="predictive__thumb"></span>';
            html += '<a class="predictive__item" href="' + p.url + '">' + img + '<span class="predictive__title">' + p.title + "</span></a>";
          });
        }
        ["pages", "articles"].forEach(function (k) {
          if (res[k] && res[k].length) {
            html += '<div class="predictive__group-title">' + (k === "pages" ? "Pages" : "Journal") + "</div>";
            res[k].forEach(function (item) {
              html += '<a class="predictive__item" href="' + item.url + '"><span class="predictive__title">' + item.title + "</span></a>";
            });
          }
        });
        container.innerHTML = html || '<div class="predictive__group-title">No matches yet</div>';
      })
      .catch(function () {});
  }

  /* --------------------------------------------------- quick add (cards) */
  function afterAdd(cart, clientX, clientY) {
    setCartCount(cart.item_count);
    if (clientX != null) spawnBurst(clientX, clientY);
    var drawer = $("[data-cart-drawer]");
    if (drawer) { renderCartDrawer(cart); openDrawer(drawer); }
    else {
      var toast = $("[data-add-toast]");
      if (toast) { toast.classList.add("show"); setTimeout(function () { toast.classList.remove("show"); }, 2600); }
    }
  }
  function initQuickAdd() {
    $$("[data-quick-add]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault(); e.stopPropagation();
        var id = btn.getAttribute("data-variant-id");
        var url = btn.getAttribute("data-product-url");
        if (!id) { if (url) window.location = url; return; }
        btn.disabled = true;
        cartAdd(id, 1)
          .then(function (line) { return getCart().then(function (c) { afterAdd(c, e.clientX, e.clientY); }); })
          .catch(function () { if (url) window.location = url; })
          .finally(function () { btn.disabled = false; });
      });
    });
  }

  /* ----------------------------------------------- product detail page */
  function initPdp() {
    var main = document.getElementById("pdp-main");
    $$(".pdp__thumb[data-thumb]").forEach(function (t) {
      t.addEventListener("click", function () {
        if (main) { main.src = t.getAttribute("data-thumb"); main.removeAttribute("srcset"); }
        $$(".pdp__thumb").forEach(function (x) { x.classList.remove("on"); });
        t.classList.add("on");
      });
    });

    var qty = $("[data-qty-input]");
    var dec = $("[data-qty-dec]");
    var inc = $("[data-qty-inc]");
    if (qty && dec && inc) {
      dec.addEventListener("click", function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
      inc.addEventListener("click", function () { qty.value = Math.min(99, (parseInt(qty.value, 10) || 1) + 1); });
    }

    var sel = $("[data-variant-select]");
    var priceEl = $("[data-price]");
    var addLabel = $("[data-add-label]");
    var addBtn = $("[data-add-btn]");
    if (sel && sel.tagName === "SELECT") {
      sel.addEventListener("change", function () {
        var opt = sel.options[sel.selectedIndex];
        if (opt && opt.dataset.price && priceEl) priceEl.textContent = opt.dataset.price;
        if (opt && addBtn) {
          var unavailable = opt.disabled;
          addBtn.disabled = unavailable;
          if (addLabel) addLabel.textContent = unavailable ? (window.themeStrings && window.themeStrings.soldOut || "Sold out") : (window.themeStrings && window.themeStrings.addToCart || "Add to cart");
        }
      });
    }

    var form = $(".pdp__form");
    var msg = $("[data-add-msg]");
    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var idField = form.querySelector('[name="id"]');
        var qtyField = form.querySelector('[name="quantity"]');
        var id = idField ? idField.value : null;
        var quantity = qtyField ? parseInt(qtyField.value, 10) || 1 : 1;
        if (!id) return;
        if (msg) msg.hidden = true;
        cartAdd(id, quantity)
          .then(function () { return getCart().then(function (c) { afterAdd(c, window.innerWidth / 2, window.innerHeight / 2); }); })
          .catch(function (err) {
            if (msg) { msg.hidden = false; msg.textContent = (err && err.description) || "Sorry, that couldn't be added."; }
          });
      });
    }

    $$("[data-share]").forEach(function (b) {
      b.addEventListener("click", function () {
        var url = b.getAttribute("data-share");
        if (navigator.share) { navigator.share({ url: url, title: document.title }).catch(function () {}); }
        else if (navigator.clipboard) { navigator.clipboard.writeText(url); b.textContent = "Link copied ✓"; }
      });
    });
  }

  /* ------------------------------------------------ cart page + drawer */
  function renderCartDrawer(cart) {
    var list = $("[data-cart-drawer-items]");
    var foot = $("[data-cart-drawer-foot]");
    var totalEl = $("[data-cart-drawer-total]");
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
    if (foot) foot.hidden = cart.item_count === 0;
    if (!list) return;
    if (cart.item_count === 0) {
      list.innerHTML = '<div class="cart-drawer__empty"><p>Your basket is napping</p><a href="/collections/all" class="btn btn--primary" style="margin-top:14px">Browse the studio</a></div>';
      return;
    }
    list.innerHTML = cart.items.map(function (item) {
      var img = item.image ? '<img class="art__img" src="' + item.image + '" width="92" height="92" alt="" loading="lazy">' : "";
      var opt = (item.variant_title && item.variant_title.indexOf("Default") === -1) ? '<div class="cart-row__opt">' + item.variant_title + "</div>" : "";
      return '<div class="cart-row" data-item-key="' + item.key + '">' +
        '<div class="cart-row__media"><div class="art art--photo" style="background:var(--paper-2)">' + img + "</div></div>" +
        "<div>" + opt + '<div class="cart-row__name">' + item.product_title + "</div>" +
        '<div class="qty qty--sm" style="margin-top:8px">' +
        '<button type="button" aria-label="Decrease" data-cart-dec data-key="' + item.key + '" data-qty="' + item.quantity + '">−</button>' +
        '<span data-item-qty>' + item.quantity + "</span>" +
        '<button type="button" aria-label="Increase" data-cart-inc data-key="' + item.key + '" data-qty="' + item.quantity + '">+</button></div></div>' +
        '<div class="cart-row__right"><span class="cart-row__price">' + formatMoney(item.final_line_price) + "</span>" +
        '<button type="button" class="cart-row__rm" data-cart-remove data-key="' + item.key + '">remove</button></div></div>';
    }).join("");
    bindCartControls();
  }

  function refreshCartPage() {
    return fetch(window.location.pathname, { headers: { "X-Requested-With": "fetch" } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        ["[data-cart-items]", "[data-cart-summary]"].forEach(function (sel) {
          var fresh = doc.querySelector(sel), cur = document.querySelector(sel);
          if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        });
        // keep the summary's own data-subtotal attribute fresh so the ship bar recomputes
        var freshSummary = doc.querySelector("[data-cart-summary]"), curSummary = document.querySelector("[data-cart-summary]");
        if (freshSummary && curSummary) curSummary.setAttribute("data-subtotal", freshSummary.getAttribute("data-subtotal"));
        bindCartControls();
        initShipBar();
      });
  }

  function changeLine(key, q, fromDrawer) {
    return cartChange(key, q).then(function (cart) {
      setCartCount(cart.item_count);
      if (fromDrawer) { renderCartDrawer(cart); }
      else if ($("[data-cart-items]")) {
        if (cart.item_count === 0) { window.location.reload(); }
        else { refreshCartPage(); }
      }
      return cart;
    });
  }

  function bindCartControls() {
    $$("[data-cart-inc]").forEach(function (b) {
      if (b.dataset.bound) return; b.dataset.bound = "1";
      b.addEventListener("click", function () { var d = b.closest("[data-cart-drawer]"); changeLine(b.getAttribute("data-key"), (parseInt(b.getAttribute("data-qty"), 10) || 1) + 1, !!d); });
    });
    $$("[data-cart-dec]").forEach(function (b) {
      if (b.dataset.bound) return; b.dataset.bound = "1";
      b.addEventListener("click", function () { var d = b.closest("[data-cart-drawer]"); changeLine(b.getAttribute("data-key"), (parseInt(b.getAttribute("data-qty"), 10) || 1) - 1, !!d); });
    });
    $$("[data-cart-remove]").forEach(function (b) {
      if (b.dataset.bound) return; b.dataset.bound = "1";
      b.addEventListener("click", function () { var d = b.closest("[data-cart-drawer]"); changeLine(b.getAttribute("data-key"), 0, !!d); });
    });
  }

  /* ----------------------------------------- free-shipping progress bar */
  function initShipBar() {
    var s = $("[data-cart-summary]");
    if (!s) return;
    var sub = parseFloat(s.dataset.subtotal) || 0;
    var thr = parseFloat(s.dataset.threshold) || 0;
    if (thr <= 0) return;
    var bar = s.querySelector("[data-ship-bar]");
    if (bar) bar.style.width = Math.min(100, Math.round((sub / thr) * 100)) + "%";
    var note = s.querySelector("[data-ship-note]");
    if (note) {
      note.innerHTML = sub >= thr
        ? "<b>Free shipping</b> unlocked 🌿"
        : "Add <b>" + formatMoney(Math.max(0, (thr - sub)) * 100) + "</b> more for free shipping";
    }
  }

  /* ----------------------------------------------- announcement rotate */
  function initAnnouncement() {
    var bar = $("[data-announcement][data-rotate]");
    if (!bar || reduceMotion) return;
    var msgs = $$("[data-announcement-msg]", bar);
    if (msgs.length < 2) return;
    var i = 0, speed = (parseInt(bar.dataset.rotate, 10) || 5) * 1000;
    setInterval(function () {
      msgs[i].classList.remove("is-active");
      i = (i + 1) % msgs.length;
      msgs[i].classList.add("is-active");
    }, speed);
  }

  /* ----------------------------------------------------- facets auto-submit */
  function initFacets() {
    var form = $("[data-facets]");
    if (!form) return;
    var sort = form.querySelector("[data-facet-sort]");
    if (sort) sort.addEventListener("change", function () { form.submit(); });
    $$('input[type="checkbox"]', form).forEach(function (cb) {
      cb.addEventListener("change", function () { form.submit(); });
    });
  }

  function init() {
    initLeaves();
    initLazyVideo();
    setCartCount(parseInt((($("[data-cart-quantity]") || {}).textContent) || "0", 10));
    initDrawers();
    initSearch();
    initQuickAdd();
    initPdp();
    bindCartControls();
    initShipBar();
    initAnnouncement();
    initFacets();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
